import   React,
       { useEffect,
         useState,
         useContext } from 'react';
//import { createTheme } from '@material-ui/core/styles'; // https://github.com/mui-org/material-ui/pull/26004
import { createTheme } from '@material-ui/core/styles'; // https://github.com/mui-org/material-ui/pull/26004
import { withRouter,
         Redirect } from 'react-router-dom';
import { Typography,
         Button,
         AppBar,
         Tabs,
         Tab,
         Box,
         Container } from '@material-ui/core';
import { makeStyles,
         withStyles } from '@material-ui/core/styles';
import { faAngleDoubleRight,
         faMask,
         faSun,         // today
         faDumbbell,    // condition
         faHandPointer, // agility
         faBullseye,    // skill
         faTachometerAlt, // challenge
         faEnvelope } from '@fortawesome/free-solid-svg-icons';     //icons: https://fontawesome.com/icons

import {
         FaSun,         // today
         FaDumbbell,    // condition
         FaHandPointer, // agility
         FaBullseye,    // skill
         FaStopWatch,   // challenge
         FaBowArrow } from '../assets/Icons';     //icons: https://fontawesome.com/icons

import { getTutorial, processEasterEggAction } from '../util/util';
import { CONSTS, INFO,
         CONSLOG,
         REACT_STATES,
         TIMES, } from '../util/object';
import { GATag, Stack } from "../util/tools";
import { appContext } from "./index";
import { GoBack, Count, ShowCatalogItems } from "./Util";
import { InternMap } from 'd3';
import Tutorial from "./Tutorial";
import { Wait,
         Spacer,
         UTIL_useStyles,
        } from "./Util";

import '../styles/Catalog.css'      // access to raw CSS animation capabilities
    // .news { animation : slide 10s linear infinite; }


// COLOR PALETTE
// src: https://coolors.co
// #091F34  Oxford Blue (9, 31, 52)
// #12355B  Prussian Blue (18, 53, 91) -> challenge
// #758ECD  Glaucous (117, 142, 205)
// #2B4178  Dark Cornflower Blue (43, 65, 120) -> title, button
// #9AD2CB  Middle Blue Green (154, 210, 203)
// #397367  Hookers Green   (57, 115, 103) -> no
// #2F4B26  Hunter Green (47, 75, 38)
// #2D625D  Skobeloff (45, 98, 93) -> analyze
// #366d68  Mertle Green (54, 109, 104) -> learn

/*
const theme = createTheme({
  overrides: {
    MuiButtonBaseRoot: {
        //color: 'red',
      text: {
        color: 'red',
      },
    },
  },
});
*/


// src: https://material-ui.com/customization/theming/
const theme = createTheme({
    palette: {
      primary: { main: '#f0f' },
      secondary: { main: '#ff0' },
    },
});

const auth_useStyles = makeStyles(theme => ({
    catalog_root: {
        display: 'flex',
        position: 'absolute',
        height: '100%',
        width: '100%',
        maxHeight: '100%',
        maxWidth: '100%',
        marginTop: '0vh',
        padding: "0",
        paddingTop: CONSTS.GOBACK_BAR_HEIGHT1+"px",
        flexDirection: "row",
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        alignContent: 'flex-start',
        backgroundColor: '#666d9f',
        overflowY: "auto",
        zIndex: '300',              // catalog overlay
    },
    catalog_button: {
        "&:hover": {
            color: 'yellow',
            backgroundColor: '#3b58c1',
            borderColor: 'rgba(255,255,255,0)',
        },
		fontSize: '1.2rem',
        height: '8vh',
        width: '20vh',
        minWidth: '180px',
        minHeight: '60px',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: '0.5vh',
        padding: '10px',
        backgroundColor: 'rgba(20, 70, 162, 0.9)',
        color: 'white',
        borderColor: 'rgba(255,255,255,0)',
        borderRadius: '15px',
        border: '0px',
        //boxShadow: '0 10 20 0',
        boxShadow: 'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: '310',              // catalog overlay
    },
    app_bar: {
        display: "flex",      // not needed at item level
        height: '45px',
        width: '100%',
        backgroundColor: '#628c9e',        //'#628c9e',
        zIndex: '350',              // catalog overlay
    },
    catalog_tabs: {
        display: "flex",      // not needed at item level
        padding: '0',
        height: '40px',
        minHeight: '40px',
        backgroundColor: '#628c9e',
        //color: "#ccc8c8",
        //color: "#eee8e8",
        color: "#ffffff",
    },
    catalog_tab: {
        display: "flex",      // not needed at item level
        padding: '0',
        paddingLeft: '10px',
        paddingRight: '10px',
        height: '40px',
        minHeight: '40px',
        //backgroundColor: '#628c9e',
    },
    catalog_panel_inner: {
        display: "flex",      // not needed at item level
        position: 'relative',
        flexWrap: 'wrap',
        overflowY: "auto",
        justifyContent: 'flex-start',       //'space-evenly',
        alignContent: 'flex-start',       //'space-evenly',
        width: "100%",
        height: "100%",
        padding: '0',
        margin: '0',
        //height: "calc(100% - 50px)",
    },
    /* MOVED TO .CSS
    catalog_panel: {
        display: "flex",      // not needed at item level
        padding: '0',
        margin: '0',
        width: "100%",
        height: "calc(100% - 50px)",
        paddingTop: '10px',
        paddingLeft: '10px',
        flexWrap: 'wrap',
        overflowY: "auto",
        justifyContent: 'flex-start',       //'space-evenly',
        alignContent: 'flex-start',       //'space-evenly',
        position: 'relative',
        transition: "margin .5s",
    },
    */
    easter_container: {
        position: 'absolute',
        //left: '0',
        bottom: '0px',
        width: '60px',
        height: '30px',
        zIndex: '1000',
        //backgroundColor: 'red',
    },
    conslog_container: {
        position: 'relative',
		fontSize: '0.6rem',
        padding: '10px',
        margin: '0',
        //paddingTop: CONSTS.GOBACK_BAR_HEIGHT+"px",
        height: "auto",
        width: "auto",
        maxWidth: '100%',
    },
}));


// Display top level menu
const Catalog = (props) => {
    const classes = auth_useStyles();
    const Classes = UTIL_useStyles();
    const { State, Dispatch } = useContext(appContext);
    function setState(name, value) {
        //console.log("setState:  ",name," =", value, " @", Stack(new Error().stack));
        Dispatch({ type: [name], value: value });   // reducer wrapper
    }
    const [ TabValue, setTabValue ] = useState(0);
    const [ Refresh, setRefresh ] = useState(0);
    const [ ShowWait, setShowWait ] = useState(false);
    const [ Warning, setWarning ] = useState("");
    const [ Secret, setSecret ] = useState(false);
    const [ ShowConsole, setShowConsole ] = useState(false);
    const [ Show, setShow ] = useState(null);
    const [ SettingOn, setSettingOn ] = useState("");
    const [ ShowTutorial, setShowTutorial ] = useState(false);
    const [ DelayShow, setDelayShow ] = useState(null);     // console log

    const panelRef = React.useRef()

    //console.log("catalog.90:  props=",props);
    useEffect(() => {
        console.log("catalog.236:  ####### FIRST CATALOG INITIALIZE   props.Tab=",props.Tab, "  props.Groups=",props.Groups, " props.Items=",props.Items);
        setTabValue(props.Tab);

        /* DOES NOT WORK
        var panel = document.querySelector('#catalog_panel');
        panel.addEventListener('touchstart', handleTouchStart, {once: true});
        panel.addEventListener('touchmove', handleTouchMove, {once: true});
        panel.addEventListener('touchend', handleTouchEnd, {once: true});
        */

        if ((props.Tab !== undefined) && (props.Groups[props.Tab] !== undefined)) {
            INFO.tut_module = props.Groups[props.Tab].type;
            INFO.tut_op = props.Groups[props.Tab].hash;
            var show = getTutorial(INFO.tut_module, INFO.tut_op);
            if(show !== null) {
                setShow(show);
                //setShowTutorial(true);
            }
        }

        return function cleanup() {
            /*
            panel.removeEventListener('touchstart', handleTouchStart, {once: true});
            panel.removeEventListener('touchmove', handleTouchMove, {once: true});
            panel.removeEventListener('touchend', handleTouchEnd, {once: true});
            */
        }
    }, [1]);

    useEffect(() => {
        //console.log("Catalog.62:   Display Refresh  ", props.Items);
        console.log("catalog.253:  . . . . . .  REFRESH   props.Tab=",props.Tab, "  props.Groups=",props.Groups, " props.Items=",props.Items);
    }, [props.Refresh, Refresh, props.Items, props.Groups]);

    useEffect(() => {
        setTabValue(props.Tab);
    }, [props.Tab]);

    useEffect(() => {
        console.log("catalog.274:  . . . . . . CHANGE  TabValue=",TabValue, "  props.Groups=",props.Groups, " props.Items=",props.Items);
    }, [TabValue]);


    useEffect(() => {
        var out = CONSLOG.replace(/(?:\r\n|\r|\n)/g, '<br>');       // insert <br> for line break
        //console.log("catalog.293:   Catalog Cons Log  =", out);

        var ele = document.getElementById('cons_log')
        if (ele !== null) {
            ele.innerHTML = out;
        }
    }, [ShowConsole]);


    const handleDismissWait = event => {
        console.log("train.224:  DISMISS <WAIT>  ");
        setShowWait(false);   // Dismiss display but may still run in background
    }


    const handleEasterEgg = (cmd) => event => {

        var xx = null.z;

        INFO.easter_egg.push(cmd);
        //console.log("catalog.256: ----->  REACHED HANDLE_EASTER_EGG   ", INFO.easter_egg);
        var [ code, text ] = processEasterEggAction();
        switch (code) {
            case 1:
                // secret menu
                setSecret(true);
                setShowWait(true);
                break;
            case 2:
                // show text 
                INFO.easter_egg = [];
                setWarning(text);
                setShowWait(true);
                break;
        }
    }

    const handleShowTutorial = () => {
        console.log("catalog.240: ----->  REACHED HANDLE_SHOW_TUTORIAL");
        props.ShowTutorial();
    }

    const handleDismissTutorial = () => {
        console.log("catalog.244: ----->  REACHED HANDLE_DISMISS_TUTORIAL");
        //setShowTutorial(false);
        props.DismissTutorial();
    }

    const handleTabSelect = (event, tab) => {
        console.log("catalog.206: ----->  REACHED HANDLE_TAB_SELECT tab=", tab);
        setTabValue(tab);
        INFO.drill_chain_mode = false;      // manually select drills, always disable chain mode
        INFO.tut_module = props.Groups[tab].type;
        INFO.tut_op = props.Groups[tab].hash;
        //var show = getTutorial(INFO.tut_module, INFO.tut_op);
        //setShow(show);
        //setTabValue(props.Groups[tab].key);

        props.TabSelect(tab);  // tell the parent to update
    }

    function a11yProps(index) {
        return {
            id: `wrapped-tab-${index}`,
            'aria-controls': `wrapped-tabpanel-${index}`,
        };
    }

    const handleSettingToggle = () => {
        //console.log("catalog.316:   Catalog Toggle  cmd=",SettingOn, "  props=",props);
        props.ToggleSetting();
        //setRefresh(Date.now());
    }

    const handleConsLog = (event) => { 
        setShowConsole(true);
        //setLog(out);
    }

    const NO_SWIPE_MODE = false;
    const handleTouchMove = (event) => { 
        if(NO_SWIPE_MODE || INFO.override.disable_catalog_swipe) return;

        event.preventDefault();
        var touches = event.targetTouches;
        var touch = touches[0];
        const panel = panelRef.current;
        //console.log("catalog.352:   Touch MOVE Detected!   event=",event);

        var MoveX = touch.clientX;
        var StartX = INFO.drag_start_x;
        var delta = Math.abs(MoveX - StartX);
        if ((MoveX > 0) && (delta > 100)) {
            if (MoveX < StartX) {
                //props.Move(1);
                var new_tab = TabValue + 1;
                if(new_tab < props.Groups.length) {
                    handleTabSelect(event, new_tab);
                    panel.classList.add('move_right')
                }
                console.log("    **** >>>>>>>> MOVE RIGHT  tab=",new_tab,"  delta=",delta, " start=",StartX, "  moveX=",MoveX)
            } else {
                var new_tab = TabValue - 1;
                if(new_tab >= 0) {
                    //handleTabSelect(event, new_tab);
                    panel.classList.add('move_left');
                    setDelayShow(new_tab);
                }
                console.log("    **** MOVE LEFT <<<<<<<<<  tab=",new_tab,"  delta=",delta, " start=",StartX, "  moveX=",MoveX)
            }
            INFO.drag_start_x = MoveX;     // prevent double skip
        }
    }

    const handleTouchStart = (event) => { 
        if(NO_SWIPE_MODE || INFO.override.disable_catalog_swipe) return;

        //event.preventDefault();           // CAN NOT USE, THIS WILL BLOCK DRILL-CLICKS
        var touches = event.targetTouches;
        var touch = touches[0];
        const panel = panelRef.current;

        panel.classList.remove('move_left')
        panel.classList.remove('move_right')
        if (touch.clientX > 0) {
            INFO.drag_start_x = touch.clientX;
            console.log("catalog.352:   Touch START Detected!   startX=",INFO.drag_start_x ,"   event=",event);
            //panel.classList.add('active')
        }
    }

    const handleTouchEnd = (event) => {
        if(NO_SWIPE_MODE || INFO.override.disable_catalog_swipe) return;

        //event.preventDefault();           // CAN NOT USE, THIS WILL BLOCK DRILL-CLICKS
        var touches = event.targetTouches;
        var touch = touches[0];

        console.log("catalog.352:   Touch END Detected!   startX=",INFO.drag_start_x ,"   DelayShow=",DelayShow, " TabValue=",TabValue);  // event=",event);
        if (DelayShow !== null) {
            handleTabSelect(event, DelayShow);
            setDelayShow(null);
        }

        //const panel = panelRef.current;
        //panel.classList.remove('left')
        //panel.classList.remove('right')
    }




    return (
        <React.Fragment>
            <GoBack Title={props.Title} 
                Type={props.Type}
                Icon={props.Icon} 
                ToggleSetting={handleSettingToggle}
                GoBack={props.GoBack} 
                Tutorial={handleShowTutorial} />
            <Container id="catalog_root" className={props.Theme + " " + classes.catalog_root}>
                {ShowConsole && <Container id="cons_log" className={classes.conslog_container}></Container>}
                { ShowWait && 
                    <Wait Warning={Warning} 
                          Secret={Secret} 
                          ConsLog={handleConsLog} 
                          Dismiss={handleDismissWait} /> }

                <AppBar position="static" color="default" className={classes.app_bar}>
                    <Tabs value={TabValue} 
                        indicatorColor="primary"
                        variant="scrollable"
                        scrollButtons="auto"
                        className={classes.catalog_tabs}
                        onChange={handleTabSelect} >

                        {props.Groups.map( (group, index) => {
                            return (
                                <Tab label={group.name} 
                                    value={index}
                                    wrapped 
                                    key={"tab"+index} 
                                    {...a11yProps(index)}
                                    className={classes.catalog_tab} />
                            )
                        })}
                    </Tabs>
                </AppBar>


                <Container id="catalog_panel" className="catalog_panel" ref={panelRef} 
                            onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} >  
                    <div className={classes.catalog_panel_inner}>

                        <ShowCatalogItems TabValue={TabValue} {...props} />
                        <Spacer Height={"40px"} Width={"100%"} />
                        {/*<FaBowArrow className={Classes.icon_body} />
                        <FaBullsEye className={Classes.icon_body} />
                        <FaStopWatch className={Classes.icon_body} />*/}

                        <div key="easter1_btn" id="easter_left" className={classes.easter_container} style={{left: '0px' }} onClick={handleEasterEgg("left")}/>
                        <div key="easter2_btn" id="easter_middle" className={classes.easter_container} style={{left: 'calc(50% - 30px)' }} onClick={handleEasterEgg("mid")}/>
                        <div key="easter3_btn" id="easter_right" className={classes.easter_container}  style={{right: '0px' }} onClick={handleEasterEgg("right")}/>
                    </div>
                </Container>

            </Container>

        </React.Fragment>
    )
}

export default withRouter(Catalog)
